const TimeoutModalDisplayTextEs = {
    title: '¿Sigues ahí?',
    timeout: (sRemaining) => `Su sesión está a punto de finalizar en ${sRemaining} segundos.`,
    clickHere: 'Haga clic en continuar para permanecer conectado.',
    continue: 'Continuar',
};
export default TimeoutModalDisplayTextEs;
